export const GET_ORDER = 'GetOrder'
export const GET_ORDERS = 'GetOrders'
export const GET_CLIENT = 'GetClient'
export const GET_HEADER_CLIENT = 'GetHeaderClient'
export const BONUS_HISTORY_HEADER = 'BonusHistoryHeader'
export const GET_USER = 'GetUser'
export const GET_TABLE_DATA = 'GetTableData'
export const GET_UNVIEWED_ORDERS = 'GetUnviewedOrders'
export const GET_WIKI_SPACE = 'GetWikiSpace'
export const GET_WIKI_FOLDER = 'GetWikiFolder'
export const GET_NOTIFICATIONS_COUNT = 'GetNotificationsCount'
